"use strict";

var React = require("react/addons");

var Features = React.createClass({
  displayName: "Features",

  render: function render() {
    return React.createElement(
      "div",
      { className: "features" },
      React.createElement(
        "h2",
        { className: "features__header" },
        "Features"
      ),
      React.createElement(
        "ul",
        { className: "features__list" },
        React.createElement(
          "li",
          { className: "features__point" },
          "Search text highlighting"
        ),
        React.createElement(
          "li",
          { className: "features__point" },
          "Single or multiple selection"
        ),
        React.createElement(
          "li",
          { className: "features__point" },
          "Custom results rendering"
        )
      )
    );
  }
});

module.exports = Features;


/*****************
 ** WEBPACK FOOTER
 ** ./example/components/features.jsx
 ** module id = 8
 ** module chunks = 0
 **/